import { useLanguage } from '../LanguageContext';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

const logWithDetails = (message) => {
  const error = new Error();
  const stackLines = error.stack.split("\n");
  const callerInfo = stackLines[2]?.trim() || "Unknown location";
  console.log(`📌 [Unauthorized.js] ${message} @ ${callerInfo}`);
};

const Unauthorized = ({ setShowNavbar }) => {
  const { t } = useLanguage();  // ✅ Accept as a prop
  useEffect(() => {
    if (setShowNavbar) {  // ✅ Ensure it's defined before calling
      setShowNavbar(false);
    }
    logWithDetails("🚨 User attempted to access unauthorized page.");

    const fetchUserRole = async () => {
      try {
        const response = await axiosInstance.get('/api/check-auth', { withCredentials: true });
        logWithDetails(`🔍 Fetched User Role: ${response.data.role || "No Role Found"}`);
      } catch (error) {
        logWithDetails(`❌ Error fetching user role: ${error.message}`);
      }
    };
    fetchUserRole();

    logWithDetails(`📌 Current URL: ${window.location.href}`);
    logWithDetails(`🍪 Cookies: ${document.cookie}`);

    fetch(window.location.href, { method: 'HEAD', credentials: 'include' })
      .then(response => {
        const headers = [...response.headers.entries()];
        logWithDetails(`📡 Response Headers: ${JSON.stringify(headers)}`);
      })
      .catch(error => logWithDetails(`❌ Error fetching headers: ${error.message}`));
  }, [setShowNavbar]);  // ✅ Dependency added

  return (
    <div className="container">
      <h1>{t("Unauthorized Access")}</h1>
      <p>{t("You do not have permission to view this page.")}</p>

      <p>🔍 <strong>{t("Debug Info:")}</strong>{t("Check the console (`F12 → Console`) for detailed logs.")}</p>

      <Link to="/login">
        <button>{t("Go to Login")}</button>
      </Link>
    </div>
  );
};

export default Unauthorized;
